import type { Article } from './types';

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '2024欧冠决赛前瞻：豪门对决谁能问鼎欧洲之巅',
    excerpt: '本赛季欧冠联赛即将迎来最终的巅峰对决，两支欧洲顶级豪门将在决赛中相遇。本文为您深度解析双方战术体系、核心球员状态及历史交锋记录。',
    content: `<p>经过长达9个月的激烈角逐，2024赛季欧洲冠军联赛终于迎来了最终的巅峰对决。两支欧洲足坛的顶级豪门将在伊斯坦布尔的阿塔图尔克奥林匹克体育场展开终极较量。</p>
<p>回顾两支球队的晋级之路，每一轮淘汰赛都充满了戏剧性。从小组赛的稳扎稳打，到淘汰赛的惊心动魄，双方都展现出了冠军球队应有的韧性与实力。</p>
<h3>战术分析</h3>
<p>从战术层面来看，这场比赛将是一场攻防博弈的经典对决。一方擅长高位压迫和快速转换，另一方则以控球为主导、耐心寻找破绽。中场控制权的争夺将成为决定比赛走向的关键因素。</p>
<h3>核心球员</h3>
<p>双方阵中都有能够改变比赛走向的超级球星。进攻端的速度与技术，防守端的稳健与经验，门将位置的出色发挥——每一个位置的对决都值得期待。</p>
<h3>历史交锋</h3>
<p>两支球队在欧冠历史上曾多次相遇，互有胜负。最近5次交锋中，双方各取2胜1平，实力可谓旗鼓相当。决赛的舞台往往超出常规战术范畴，心理素质和临场发挥往往比纸面实力更加重要。</p>
<p>无论最终谁捧起大耳朵杯，这场决赛都将成为欧洲足球史上的经典战役。让我们共同期待这场足球盛宴的到来。</p>`,
    category: '足球',
    categorySlug: 'football',
    image: 'https://readdy.ai/api/search-image?query=Professional%20soccer%20stadium%20at%20night%20with%20dramatic%20lighting%2C%20champions%20league%20atmosphere%2C%20green%20pitch%20with%20spotlights%2C%20sports%20photography%20style%2C%20clean%20and%20dynamic%20composition%2C%20dark%20background%20with%20stadium%20lights%20glow%2C%20editorial%20sports%20photography&width=1200&height=675&seq=kaiyun-article-01&orientation=landscape',
    author: '体育观察员',
    date: '2024-08-10',
    readTime: '8分钟',
    tags: ['欧冠', '决赛', '足球', '豪门'],
    featured: true,
  },
  {
    id: 'article-2',
    title: 'NBA新赛季格局大变：休赛期重磅交易盘点',
    excerpt: 'NBA休赛期交易市场风起云涌，多位全明星球员改换门庭。本文全面盘点各队操作，分析新赛季联盟格局的巨大变化。',
    content: `<p>2024年NBA休赛期堪称近年来最热闹的交易窗口。多名全明星级别球员通过交易或自由签约更换了球队，联盟格局发生了翻天覆地的变化。</p>
<p>从选秀大会到自由市场开启，再到夏季联赛的落幕，这个夏天给了球迷太多惊喜和意外。</p>
<h3>东部格局</h3>
<p>东部多支球队通过针对性补强，阵容深度有了质的飞跃。卫冕冠军保持了核心阵容的稳定，而几支传统劲旅则通过交易获得了即战力，新赛季东部的竞争将异常激烈。</p>
<h3>西部格局</h3>
<p>西部依然是群雄逐鹿的局面。几支年轻球队的崛起让季后赛席位争夺更加白热化。老牌强队虽然核心年龄增长，但经验和默契依然是他们的最大优势。</p>
<h3>新赛季展望</h3>
<p>随着训练营的临近，各队新阵容的磨合情况将成为关注焦点。新赛季的NBA，值得每一位篮球爱好者期待。</p>`,
    category: '篮球',
    categorySlug: 'basketball',
    image: 'https://readdy.ai/api/search-image?query=Professional%20basketball%20court%20with%20dramatic%20arena%20lighting%2C%20NBA%20atmosphere%2C%20hardwood%20floor%20texture%2C%20sports%20photography%20style%2C%20clean%20and%20energetic%20composition%2C%20dark%20background%20with%20spotlights%2C%20editorial%20sports%20photography&width=1200&height=675&seq=kaiyun-article-02&orientation=landscape',
    author: '篮坛快讯',
    date: '2024-08-09',
    readTime: '6分钟',
    tags: ['NBA', '交易', '篮球', '新赛季'],
    featured: true,
  },
  {
    id: 'article-3',
    title: '温网男单决赛回顾：五盘大战缔造经典',
    excerpt: '温布尔登网球锦标赛男单决赛上演史诗级五盘大战，两位世界顶尖选手在草地赛场上奉献了一场永载史册的经典对决。',
    content: `<p>温布尔登网球锦标赛男单决赛在万众瞩目中拉开帷幕。两位世界排名前列的顶尖选手在历史悠久的中央球场展开了一场令人窒息的五盘鏖战。</p>
<p>比赛从第一分开始就进入了白热化状态，双方在底线展开了激烈对攻，精彩的制胜分此起彼伏。</p>
<h3>第一盘：试探与突破</h3>
<p>开局阶段双方都在试探对手的状态和战术意图，比分交替上升。关键的破发点出现在第七局，经过多次平分后终于有人率先取得了突破。</p>
<h3>中盘：意志的较量</h3>
<p>随着比赛的深入，体能消耗开始显现。但两人都展现出了顶级运动员的意志品质，第四盘更是打出了令人窒息的抢七大战。</p>
<h3>决胜盘：伟大的诞生</h3>
<p>进入决胜盘，全场气氛达到了顶点。每一次击球都牵动着现场观众的心弦。最终，经过四个多小时的鏖战，这场注定载入史册的经典对决画上了句号。</p>`,
    category: '网球',
    categorySlug: 'tennis',
    image: 'https://readdy.ai/api/search-image?query=Professional%20tennis%20court%20grass%20surface%20at%20wimbledon%20style%2C%20elegant%20white%20attire%2C%20dramatic%20natural%20light%2C%20clean%20green%20background%2C%20sports%20photography%20style%2C%20editorial%20quality%2C%20premium%20sports%20aesthetic&width=1200&height=675&seq=kaiyun-article-03&orientation=landscape',
    author: '网球世界',
    date: '2024-08-08',
    readTime: '7分钟',
    tags: ['网球', '温网', '大满贯', '经典'],
    featured: false,
  },
  {
    id: 'article-4',
    title: '英雄联盟S14全球总决赛：LPL赛区三队晋级八强',
    excerpt: '英雄联盟S14全球总决赛小组赛阶段落下帷幕，LPL赛区表现强势，三支战队成功晋级淘汰赛阶段，向冠军发起冲击。',
    content: `<p>经过两周紧张激烈的小组赛争夺，英雄联盟S14全球总决赛八强名单正式确定。LPL赛区延续了一贯的强势表现，三支战队从各自小组中脱颖而出。</p>
<p>回顾小组赛的表现，LPL战队展现出了令人惊叹的竞技状态和战术多样性。无论是在对线期的压制力还是团战中的协同配合，都处于世界顶尖水平。</p>
<h3>头号种子表现</h3>
<p>作为LPL的头号种子，这支战队在小组赛中展现出了统治级的表现。以全胜战绩锁定小组第一，每一场比赛都打出了极高的竞技水准。</p>
<h3>黑马崛起</h3>
<p>LPL三号种子在赛前并不被外界看好，但他们用实力证明了自己。击败多个赛区的冠军队伍，成为本届赛事最大的惊喜。</p>
<h3>淘汰赛展望</h3>
<p>八强对阵已经出炉，LPL三支战队分别对阵不同赛区的对手。从实力对比来看，LPL赛区有望在四强中占据多个席位，向最终的召唤师奖杯发起冲击。</p>`,
    category: '电竞',
    categorySlug: 'esports',
    image: 'https://readdy.ai/api/search-image?query=Esports%20arena%20with%20massive%20LED%20screens%20and%20crowd%2C%20gaming%20tournament%20atmosphere%2C%20futuristic%20stage%20lighting%2C%20clean%20dark%20background%20with%20colorful%20accents%2C%20dynamic%20composition%2C%20editorial%20photography%20style&width=1200&height=675&seq=kaiyun-article-04&orientation=landscape',
    author: '电竞前线',
    date: '2024-08-07',
    readTime: '5分钟',
    tags: ['英雄联盟', 'S14', 'LPL', '电竞'],
    featured: false,
  },
  {
    id: 'article-5',
    title: 'F1摩纳哥大奖赛：街道赛道的速度与激情',
    excerpt: 'F1摩纳哥大奖赛作为赛季最具挑战性的分站赛之一，狭窄的街道赛道对车手技术和赛车性能提出了极高要求。',
    content: `<p>摩纳哥蒙特卡洛，这个地中海沿岸的璀璨明珠，每年都会变身为F1世界锦标赛最具标志性的赛道。狭窄的街道、紧贴的护栏、没有容错空间——这就是摩纳哥大奖赛的魅力所在。</p>
<h3>赛道挑战</h3>
<p>摩纳哥赛道全长3.337公里，拥有19个弯道。这里没有缓冲区，任何微小的失误都可能导致赛车撞上护栏。车手需要在整个比赛周末保持高度集中。</p>
<h3>排位赛决定一切</h3>
<p>在摩纳哥，排位赛的重要性远超其他任何赛道。由于超车极其困难，拿到一个好的发车位置几乎等于成功的一半。排位赛的每一圈都充满了紧张和刺激。</p>
<h3>历史传承</h3>
<p>摩纳哥大奖赛自1929年首次举办以来，已经成为了赛车运动皇冠上的明珠。每一位F1车手都梦想着在这里夺冠，将自己的名字刻入赛车运动的史册。</p>`,
    category: '赛车',
    categorySlug: 'racing',
    image: 'https://readdy.ai/api/search-image?query=Formula%201%20racing%20car%20on%20monaco%20street%20circuit%2C%20dramatic%20angle%2C%20mediterranean%20backdrop%2C%20speed%20motion%20blur%2C%20clean%20composition%2C%20professional%20motorsport%20photography%2C%20editorial%20style%2C%20vibrant%20racing%20colors&width=1200&height=675&seq=kaiyun-article-05&orientation=landscape',
    author: '赛车视界',
    date: '2024-08-06',
    readTime: '6分钟',
    tags: ['F1', '摩纳哥', '赛车', '大奖赛'],
    featured: false,
  },
  {
    id: 'article-6',
    title: 'UFC重量级冠军战：新时代的重量级霸主诞生',
    excerpt: 'UFC重量级冠军争夺战上演震撼对决，新生代选手以令人窒息的表现为重量级带来了全新格局。',
    content: `<p>UFC八角笼中，重量级的王座迎来了新一代的挑战者。这场备受瞩目的冠军战从一开始就充满了火药味，双方在赛前的对视环节就已经点燃了全场气氛。</p>
<h3>比赛进程</h3>
<p>第一回合双方都表现得相对谨慎，在试探中寻找机会。挑战者展现出了远超年龄的冷静和耐心，不急不躁地执行着自己的战术计划。</p>
<h3>转折点</h3>
<p>比赛的转折点出现在第二回合中段。一记精准的后手重拳改变了整个战局，随后的地面追击让裁判不得不介入终止比赛。</p>
<h3>新时代来临</h3>
<p>这场胜利不仅意味着一顶新冠军的诞生，更标志着UFC重量级进入了一个全新的时代。年轻、全面、富有爆发力的新一代选手已经做好了统治这个级别的准备。</p>`,
    category: '搏击',
    categorySlug: 'combat',
    image: 'https://readdy.ai/api/search-image?query=UFC%20octagon%20arena%20with%20dramatic%20spotlight%2C%20martial%20arts%20fighting%20atmosphere%2C%20dark%20background%20with%20intense%20lighting%2C%20clean%20and%20powerful%20composition%2C%20editorial%20sports%20photography%2C%20professional%20fight%20photography&width=1200&height=675&seq=kaiyun-article-06&orientation=landscape',
    author: '格斗时刻',
    date: '2024-08-05',
    readTime: '5分钟',
    tags: ['UFC', '重量级', '搏击', '冠军'],
    featured: false,
  },
  {
    id: 'article-7',
    title: '英超新赛季前瞻：六强争霸格局愈演愈烈',
    excerpt: '2024-25赛季英超联赛即将开战，传统六强球队均进行了针对性补强，新赛季的英超联赛竞争将更加白热化。',
    content: `<p>作为全球最具竞争力和商业价值的足球联赛，英超每个赛季都吸引着全世界球迷的目光。2024-25赛季即将拉开帷幕，各支球队的备战工作也已经接近尾声。</p>
<h3>卫冕冠军</h3>
<p>上赛季的冠军球队保持了核心阵容的完整性，并在关键位置进行了针对性补强。新赛季他们的目标不仅是卫冕，更希望在欧冠赛场上有所突破。</p>
<h3>挑战者阵容</h3>
<p>几支传统豪门在转会市场上也有大手笔操作。新援的加入为球队注入了新鲜血液，新赛季他们将对冠军发起强有力的冲击。</p>
<h3>黑马候选</h3>
<p>除了传统六强之外，还有几支球队在休赛期展现了雄心。通过精明的引援和青训体系的成果，他们有望在新赛季扮演搅局者的角色。</p>`,
    category: '足球',
    categorySlug: 'football',
    image: 'https://readdy.ai/api/search-image?query=English%20premier%20league%20football%20stadium%20packed%20with%20fans%2C%20green%20pitch%20under%20bright%20lights%2C%20dramatic%20atmosphere%2C%20sports%20photography%20style%2C%20clean%20and%20dynamic%20composition%2C%20editorial%20quality&width=1200&height=675&seq=kaiyun-article-07&orientation=landscape',
    author: '英超观察',
    date: '2024-08-04',
    readTime: '7分钟',
    tags: ['英超', '足球', '新赛季', '前瞻'],
    featured: false,
  },
  {
    id: 'article-8',
    title: 'NBA季后赛深度复盘：冠军之路的技术密码',
    excerpt: '深入剖析NBA总冠军球队的技术特点和战术体系，解读他们在季后赛中一路过关斩将的制胜之道。',
    content: `<p>一支球队能够在NBA的漫长赛季中脱颖而出，最终捧起总冠军奖杯，绝非偶然。从常规赛的马拉松到季后赛的短兵相接，冠军球队需要在每一个环节都做到极致。</p>
<h3>防守体系</h3>
<p>冠军球队之所以能够在季后赛中走得更远，其防守体系的完整性是关键因素。从个人防守能力到团队协防的默契度，每一个防守回合的执行力都经得起考验。</p>
<h3>进攻多样性</h3>
<p>现代篮球的进攻体系要求球队具备多维度的得分能力。冠军球队在进攻端展现出了令人惊叹的丰富性——既有稳定的半场阵地进攻，也有高效的反击转换。</p>
<h3>球星关键时刻</h3>
<p>季后赛的本质是球星的对决。冠军球队的核心球员在关键时刻总能挺身而出，用个人能力改变比赛走向，这正是冠军基因的最佳体现。</p>`,
    category: '篮球',
    categorySlug: 'basketball',
    image: 'https://readdy.ai/api/search-image?query=NBA%20championship%20celebration%20with%20confetti%20and%20trophy%2C%20basketball%20arena%20atmosphere%2C%20dramatic%20lighting%2C%20clean%20composition%2C%20professional%20sports%20photography%2C%20editorial%20style%2C%20golden%20trophy%20focus&width=1200&height=675&seq=kaiyun-article-08&orientation=landscape',
    author: '篮球解析',
    date: '2024-08-03',
    readTime: '8分钟',
    tags: ['NBA', '季后赛', '总冠军', '深度分析'],
    featured: false,
  },
];